import React, { useState, useEffect } from 'react';
import '../../../assets/css/BloomSliderSection.css';
import womanMeasuringImage from '../../../assets/images/two_women.svg';
import tailor from '../../../assets/images/tailor.svg';
import lady_belt from '../../../assets/images/lady_belt.svg';
import book from '../../../assets/images/book.svg';
import bloom_works from '../../../assets/images/bloom_works.svg';

const slidesData = [
    {
    id: 1,
    image: bloom_works,
    altText: "Woman holding a measuring tape",
    title: "We come to you, wherever you are.",
    description: "Whether you’re resting at home or preparing in a hospital, a Bloom consultant will visit you at your convenience. This is your space, and we honour it."
  },
  {
    id: 2,
    image: lady_belt,
    altText: "Woman holding a measuring tape",
    title: "We measure with care and compassion.",
    description: "With compassion and privacy at the forefront, we take only the measurements we need, in a way that feels safe and completely comfortable."
  },
  {
    id: 3,
    image: book,
    altText: "Illustration representing a gentle process",
    title: "You choose from breathable, curated fabrics.",
    description: "We bring a selection of soft, breathable, skin-loving fabrics for you to explore. Choose what speaks to you, in colour, texture, and comfort."
  },
  {
    id: 4,
    image: tailor,
    altText: "Illustration emphasizing comfort",
    title: "We create your Bloom, just for you.",
    description: "Your gown is custom-made to your size, preferences, and medical needs. Every detail, from seam placement to pocket positioning is thoughtfully considered to support your healing."
  },
  {
    id: 5,
    image: womanMeasuringImage,
    altText: "Illustration emphasizing comfort",
    title: "We deliver it the day before your surgery.",
    description: "So when it’s time to leave the hospital, you’re not wearing a hospital gown, you’re wearing Bloom. A garment that speaks of grace, comfort, and quiet strength."
  }
];

const BloomSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % slidesData.length);
    }, 6000); // Change slide every 5 seconds

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const currentSlide = slidesData[currentIndex];

  return (
    <div className="bloom-slider-container">
      <h2 className="bloom-slider-title">How Bloom works?</h2>
      
      <div className="bloom-slide-content-wrapper">
        {/* The key prop helps React re-trigger animations on slide change if CSS animations are tied to mount */}
        <div className="bloom-slide animate-slide-in" key={currentSlide.id}>
          <div className="bloom-slide-image-container">
            <img 
              src={currentSlide.image} 
              alt={currentSlide.altText} 
              className="bloom-slide-image" 
            />
          </div>
          <div className="bloom-slide-text-container">
            <h3>{currentSlide.title}</h3>
            <p>{currentSlide.description}</p>
          </div>
        </div>
      </div>

      <div className="bloom-slider-dots">
        {slidesData.map((_, index) => (
          <span
            key={index}
            className={`bloom-slider-dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default BloomSlider;